<template>
	<div class="menuItem" @click.stop="jump">
		<div class="imagePanel" :style="{'background-image':'url(' + item['image'] + ')'}"></div>
		<div class="title">{{ item["title"] }}</div>
	</div>
</template>

<script>
export default {
	props: {
		item: null
	},
	methods: {
		jump() {
			let arg = this.item.link;
			console.log(arg);
			this.$emit('menu_click', arg);
		}
	}
}
</script>

<style lang="less" scoped>
.menuItem {
	width: 100%;
	height: 100%;
	cursor: pointer;
	
	.imagePanel {
		width: 100%;
		height: 145px;
		background-size: cover;
		background-position: center;
		transition: box-shadow 0.3s;
	}
	
	.title {
		margin-top: 12px;
		text-align: center;
		font-size: 1.2rem;
		font-weight: bold;
		transition: text-shadow 0.3s;
	}
	
	&:hover {
		.imagePanel {
			box-shadow: 0px 2px 4px 2px rgba(0,0,0,0.2);
		}
		
		.title {
			text-shadow: 2px 2px 4px rgba(0,0,0,0.2);
		}
	}
}
</style>
